module.exports = __webpack_public_path__ + "img/5.1bfe1d8a.gif";